import { createContext } from 'react';
import { VideoStagingContextValue } from '../common/model/type/video-staging.types';

export const VideoStagingContext =
  createContext<VideoStagingContextValue | null>(null);
